import type { FieldError } from 'react-hook-form'
import { appendErrors } from 'react-hook-form'
import type { z } from 'zod'

import { isNonEmptyArray } from '@mntn-dev/utilities'

export type ErrorMap = Record<string, FieldError>

export function parseErrorSchema(
  zodErrors: z.ZodIssue[],
  validateAllFieldCriteria: boolean,
  initialMap: ErrorMap = {}
): ErrorMap {
  const errors = zodErrors.reduce<Record<string, FieldError>>((map, error) => {
    const { code, message, path: errorPath } = error
    const path = errorPath.join('.')
    const unionIssues =
      'errors' in error && Array.isArray(error.errors)
        ? error.errors.flat()
        : 'unionErrors' in error && Array.isArray(error.unionErrors)
          ? error.unionErrors.flatMap((unionError) => unionError.errors)
          : []

    if (!map[path]) {
      if (isNonEmptyArray(unionIssues)) {
        const [unionError] = unionIssues
        map[path] = {
          message: unionError.message,
          type: unionError.code,
        }
      } else {
        map[path] = {
          message,
          type: code,
        }
      }
    }

    if (isNonEmptyArray(unionIssues)) {
      parseErrorSchema(unionIssues, validateAllFieldCriteria, map)
    }

    if (validateAllFieldCriteria) {
      const types = map[path]?.types
      const messages = types?.[code]

      map[path] = appendErrors(
        path,
        validateAllFieldCriteria,
        map,
        code,
        messages
          ? ([] as string[]).concat(messages as string[], message)
          : message
      ) as FieldError
    }

    return map
  }, initialMap)

  return errors
}
